<template>
  <el-dialog
    :title="lenInfo.lenname ? $t('langcfg.txtEdit') : $t('langcfg.txtAdd')"
    :visible.sync="showDialog"
    width="800px"
    append-to-body
    class="len"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="200px" label-position="top">
      <el-form-item :label="$t('langcfg.txtLen')" prop="lenname" style="margin-bottom: 10px">
        <el-input
          v-model="form.lenname"
          @click.native.stop.prevent="handleClick('lenname')"
          @touchend.native.stop.prevent="handleClick('lenname')"
        />
      </el-form-item>
      <el-form-item label="R" prop="r">
        <template v-for="i in numLen">
          <el-input-number
            :precision="2"
            :step="0.05"
            :max="100"
            :min="0"
            :ref="`inputr${i - 1}`"
            v-model="form.r[i - 1]"
            :key="i"
          ></el-input-number>
        </template>
      </el-form-item>
      <el-form-item label="Width" prop="width">
        <template v-for="i in numLen">
          <el-input-number
            :precision="2"
            :step="0.05"
            :max="100"
            :min="0"
            :ref="`inputwidth${i - 1}`"
            v-model="form.width[i - 1]"
            :key="i"
          ></el-input-number>
        </template>
      </el-form-item>
      <el-form-item label="ecc" prop="ecc">
        <template v-for="i in numLen">
          <el-input-number
            :precision="2"
            :step="0.05"
            :max="10"
            :min="0"
            :ref="`inputecc${i - 1}`"
            v-model="form.ecc[i - 1]"
            :key="i"
          ></el-input-number>
        </template>
      </el-form-item>
      <!-- <el-form-item label="Toric_R" prop="toric_r">
        <template v-for="i in numLen">
          <el-input-number v-model="form.toric_r[i-1]" :key="i"></el-input-number>
        </template>
      </el-form-item>-->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save">{{ $t("langcfg.txtSave") }}</el-button>
      <el-button @click="cancel">{{ $t("langcfg.txtCancel") }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import EVENTS from "../../bus";
import { canConvertNumber, objectCopy } from "../../shared/utils";
export default {
  name: "RGP-LenEdit",
  components: {},
  props: {
    lenInfo: { type: Object },
    show: Boolean
  },
  data() {
    return {
      form: {},
      rules: {
        lenname: [{ required: true, message: this.$t("langcfg.txtNameNotEmpty"), trigger: "blur" }]
      },
      numLen: 7
    };
  },
  created() {
    this.form = JSON.parse(JSON.stringify(this.lenInfo));
  },
  mounted() {
    this.$nextTick(() => {
      let self = this;
      let arr = ["r", "width", "ecc"];
      arr.forEach((inputname) => {
        for (let id = 0; id < self.numLen; id++) {
          self.$refs[`input${inputname}${id}`][0].$children[0].$el.addEventListener(
            "touchend",
            (e) => {
              e.preventDefault();
              e.stopPropagation();
              self.$bus.$emit(EVENTS.spreadKeyBoard, self.form[inputname][id], (value) => {
                if (canConvertNumber(value)) {
                  self.form[inputname][id] = parseFloat(value);
                  self.form = objectCopy(self.form);
                }
              });
            }
          );
          self.$refs[`input${inputname}${id}`][0].$children[0].$el.addEventListener(
            "click",
            (e) => {
              e.preventDefault();
              e.stopPropagation();
              self.$bus.$emit(EVENTS.spreadKeyBoard, self.form[inputname][id], (value) => {
                if (canConvertNumber(value)) {
                  self.form[inputname][id] = parseFloat(value);
                  self.form = objectCopy(self.form);
                }
              });
            }
          );
        }
      });
    });
  },
  methods: {
    handleClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.form[key], (value) => {
        this.$set(self.form, key, value);
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit("save", this.form);
        } else {
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  watch: {
    lenInfo(newVal) {
      this.form = JSON.parse(JSON.stringify(newVal));
    }
  },
  computed: {
    showDialog: {
      get: function () {
        return this.show;
      },
      set: function (val) {
        this.$emit("update:show", val);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.len {
  .el-input-number {
    width: 180px;
    margin-right: 10px;
  }
}
.el-button {
  margin-left: 5%;
  font-size: @header-fs;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/RGP-LenEdit.vue